import type { Article } from '@backmarket/http-api/src/api-specs-content/models/article-cards-list'
import type { Maybe } from '@backmarket/utils/types/Maybe'

import { transformHref } from '@backmarket/nuxt-layer-cms/utils/transformHref'

export function mapArticlesToArticleCards(
  currentUrl: URL,
  articles?: Maybe<Article[]>,
) {
  if (!articles) return []

  return articles.map((article) => {
    const { src, alt, ...imageProps } = article.image
    const link = transformHref({ href: article.link.href, currentUrl })

    return {
      category: article.translatedCategory,
      id: article.id,
      imageAlt: alt,
      imageSrc: src,
      link,
      text: article.text,
      title: article.title,
      imageProps: 'width' in imageProps ? imageProps : undefined,
    }
  })
}
